// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__28BEs","card":"Cards_card__1P4A_","infected":"Cards_infected__uq-8c","recovered":"Cards_recovered__FWovW","deaths":"Cards_deaths__7tcmf"};